<template>
    <div class="skill-dialog-header">
        <div class="skill-dialog-header__sprite">
            <v-img
                :src="img"
                :alt="imgAlt"
                contain
                width="96"
                height="96"
                :style="imgStyle"
            />
            <v-avatar
                v-if="level !== null"
                size="28"
                class="skill-dialog-header__level"
            >
                <!-- position/z-index MUSÍ být inline, ne scoped třída - Vuetify
                     .v-icon má vlastní position:relative se stejnou specificitou
                     a scoped třída by ho nepřebila (ověřeno, viz PokemonDetail.vue
                     hlavní level bublina, která ze stejného důvodu používá inline). -->
                <v-icon size="30" style="position: absolute; top: -2px; z-index: -1; color: #ffebbc;">mdi-star</v-icon>
                <span class="skill-dialog-header__level-num">{{ level }}</span>
            </v-avatar>
        </div>
        <div v-if="freeExp !== null && exp !== null" class="skill-dialog-header__stats">
            <span class="skill-dialog-header__label">{{ $t('pokemon.skillDialogHeader.freeExpLabel') }}</span>
            <div class="skill-dialog-header__free-row">
                <span class="skill-dialog-header__free-value">{{ freeExp }}</span>
                <v-icon size="22" color="#FFD700">mdi-star-box</v-icon>
            </div>
            <span class="skill-dialog-header__spent-total">{{ $t('pokemon.skillDialogHeader.spentTotalExp', {spent: spentExp, total: exp}) }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SkillDialogHeader',
        props: {
            img: {type: String, required: true},
            // Mirror pro Ditto v boji - viz PokemonDetail.vue getIconStyle.
            imgStyle: {type: Object, default: () => ({})},
            imgAlt: {type: String, default: ''},
            level: {type: Number, default: null},
            freeExp: {type: Number, default: null},
            // Celkem nasbírané za život (freeExp + utracené) - odsud se dopočítá spentExp.
            exp: {type: Number, default: null},
        },
        computed: {
            spentExp() {
                return this.exp - this.freeExp;
            },
        },
    }
</script>

<style scoped>
.skill-dialog-header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 4px 4px 16px;
    min-width: 0;
}
.skill-dialog-header__sprite {
    position: relative;
    flex: 0 0 auto;
    width: 96px;
    height: 96px;
}
.skill-dialog-header__level {
    position: absolute;
    right: -4px;
    bottom: -4px;
    background: radial-gradient(circle at 30% 30%, #ffffff, #494949);
    box-shadow: 0 1px 4px rgba(0,0,0,0.5);
}
.skill-dialog-header__level-num {
    position: relative;
    z-index: 1;
    font-weight: 900;
    font-size: 0.72rem;
    color: #000;
}
.skill-dialog-header__stats {
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 1px;
}
.skill-dialog-header__label {
    text-transform: uppercase;
    font-size: 0.65rem;
    letter-spacing: .03em;
    font-weight: 700;
    opacity: 0.6;
}
.skill-dialog-header__free-row {
    display: flex;
    align-items: baseline;
    gap: 6px;
}
.skill-dialog-header__free-value {
    font-weight: 900;
    font-size: 2rem;
    color: #1b5e20;
    font-variant-numeric: tabular-nums;
}
.theme--dark .skill-dialog-header__free-value {
    color: #66bb6a;
}
.skill-dialog-header__spent-total {
    font-size: 0.75rem;
    opacity: 0.65;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}
</style>
